let formNamespace = "search_object[forecasts_filter_group]";
let namespaced = (name) => { return formNamespace + name; };
let primaryFilterTypeName = namespaced("[primary_filter_type]");
let potentiallyList = (base) => {
  return (multi) => {
    if (!multi) return base;

    return base + "[]";
  };
};
let primaryFilterOptionName = potentiallyList(namespaced("[primary_filter_option]"));
let viewTypeName = namespaced("[view_type]");
let secondaryAreaFilterTypeName = namespaced("[secondary_area_filter_type]");
let secondaryAreaFilterOptionName = potentiallyList(namespaced("[secondary_area_filter_option]"));
let secondaryCategoryFilterTypeName = namespaced("[secondary_category_filter_type]");
let secondaryCategoryFilterOptionName = potentiallyList(namespaced("[secondary_category_filter_option]"));
let reportBookName = namespaced("[report_book]");

let FormStrings = {
  formNamespace,
  primaryFilterTypeName,
  primaryFilterOptionName,
  viewTypeName,
  secondaryAreaFilterTypeName,
  secondaryAreaFilterOptionName,
  secondaryCategoryFilterTypeName,
  secondaryCategoryFilterOptionName,
  reportBookName,
};

export default FormStrings;
